/** External links for the mobile profile hub (override via env when available). */
export const PROFILE_HUB_CONTACT_EMAIL =
  process.env.REACT_APP_PROFILE_CONTACT_EMAIL?.trim() || 'info@offizz.ai';

export const PROFILE_HUB_CONTACT_PHONE_DISPLAY =
  process.env.REACT_APP_PROFILE_CONTACT_PHONE?.trim() || '0544724804';

const PROFILE_HUB_CONTACT_WHATSAPP_E164 =
  process.env.REACT_APP_PROFILE_WHATSAPP_E164?.trim() || '972544724804';

export const PROFILE_HUB_CONTACT_WHATSAPP_URL = `https://wa.me/${PROFILE_HUB_CONTACT_WHATSAPP_E164}`;

export const PROFILE_HUB_SOCIAL = {
  facebook:
    process.env.REACT_APP_PROFILE_FACEBOOK_URL?.trim() || 'https://www.facebook.com/offizz',
  instagram:
    process.env.REACT_APP_PROFILE_INSTAGRAM_URL?.trim() || 'https://www.instagram.com/offizz.il/',
  linkedin:
    process.env.REACT_APP_PROFILE_LINKEDIN_URL?.trim() || 'https://www.linkedin.com/company/offizz',
  tiktok:
    process.env.REACT_APP_PROFILE_TIKTOK_URL?.trim() ||
    'https://www.tiktok.com/@offizz.il',
  whatsapp:
    process.env.REACT_APP_PROFILE_WHATSAPP_URL?.trim() || PROFILE_HUB_CONTACT_WHATSAPP_URL,
} as const;

export const PROFILE_HUB_TERMS_URL =
  process.env.REACT_APP_PROFILE_TERMS_URL?.trim() || 'https://offizz.ai/terms';

/** Empty until the apps are published; set the env vars to enable store links. */
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL?.trim() || '';

export const GOOGLE_PLAY_URL = process.env.REACT_APP_GOOGLE_PLAY_URL?.trim() || '';

export const PROFILE_HUB_CONTACT_URL =
  process.env.REACT_APP_PROFILE_CONTACT_URL?.trim() || `mailto:${PROFILE_HUB_CONTACT_EMAIL}`;
